import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroupToObject } from 'src/app/pipes/form-group-to-object.pipe';
import { AuthStatusService } from 'src/app/services/auth-status.service';
import { DeliveryService } from 'src/app/services/delivery.service';
import { DeluxyExperienceSalesService } from 'src/app/services/deluxy-experience-sales.service';
import { DeluxyExperienceSaleFormDialogComponent } from '../deluxy-experience-sale-form-dialog/deluxy-experience-sale-form-dialog.component';

@Component({
  selector: 'app-deluxy-experience-sale',
  templateUrl: './deluxy-experience-sale.component.html',
  styleUrls: ['./deluxy-experience-sale.component.scss']
})
export class DeluxyExperienceSaleComponent implements OnInit {

 limit:number;
 page:number;
 count:number;
 maxPage: number;
 filtered: {};
 orders: any[] = [];
 deluxyExperienceSaleForm: any;
 order:{};
 myjson: any = JSON;
 groups:any;
 selected: string = 'active';
 settings = {
  active: {
    title: "Deluxy Experience Vendite",
  },
  inactive: {
    title: "Storico Deluxy Experience Vendite",
  }
 }
 defaultPage = 1;
 defaultLimit = 100;
 defaultOrder = { 'DeluxyExperienceSales.actualOrderId': 'DESC' };
 btnDisable: boolean = false;
 deluxyExperienceOrders: any[] = [];
 
  constructor(
    private authStatusService: AuthStatusService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private router: Router,
    private deliveryService: DeliveryService,
    private deluxyExperienceSalesService: DeluxyExperienceSalesService, 
  ) { 
    this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
    this.manageDeluxyExperienceSaleFilterForm();
  }

  async ngOnInit() {
    this.selected = !this.route.snapshot.data['active'] ? 'inactive' : 'active';
    await this.filter();
  }

  manageDeluxyExperienceSaleFilterForm() {
    this.deluxyExperienceSaleForm = new FormGroup({
      'DeluxyExperienceSales.orderId': new FormControl(''),
      'DeluxyExperienceSales.actualOrderId': new FormControl(''),
      'DeluxyExperienceSales.deliveryDate_from': new FormControl(''),
      'DeluxyExperienceSales.deliveryDate_to': new FormControl(''),
      'DeluxyExperienceSales.channel': new FormControl(''),
      'DeluxyExperienceSales.total': new FormControl(''),
      'DeluxyExperienceSales.paymentStatus': new FormControl(''),
      'DeluxyExperienceSales.fullFillmentStatus': new FormControl(''),
      'DeluxyExperienceSales.deliveryMethod': new FormControl(''),
      'DeluxyExperienceSales.address': new FormControl(''),
      'DeluxyExperienceSales.phone': new FormControl(''),
      'DeluxyExperienceSales.deliveryDate': new FormControl(''),
      'DeluxyExperienceSales.vendor': new FormControl(''),
      'DeluxyExperienceSales.status': new FormControl(''),
    });
  }

  async filter() {
    let filterForm = (new FormGroupToObject()).transform(this.deluxyExperienceSaleForm);
    this.filtered = {};
    if (filterForm['DeluxyExperienceSales.orderId'])
      this.filtered['DeluxyExperienceSales.orderId'] = filterForm['DeluxyExperienceSales.orderId'];
    if (filterForm['DeluxyExperienceSales.actualOrderId'])
      this.filtered['DeluxyExperienceSales.actualOrderId'] = filterForm['DeluxyExperienceSales.actualOrderId'];
    if (filterForm['DeluxyExperienceSales.channel'])
      this.filtered['DeluxyExperienceSales.channel'] = { operator: 'like', values: [`%${filterForm['DeluxyExperienceSales.channel']}%`] };
    if (filterForm['DeluxyExperienceSales.total'])
      this.filtered['DeluxyExperienceSales.total'] = { operator: 'like', values: [`%${filterForm['DeluxyExperienceSales.total']}%`] };
    if (filterForm['DeluxyExperienceSales.paymentStatus'])
      this.filtered['DeluxyExperienceSales.paymentStatus'] = { operator: 'like', values: [`%${filterForm['DeluxyExperienceSales.paymentStatus']}%`] };
    if (filterForm['DeluxyExperienceSales.fullFillmentStatus'])
      this.filtered['DeluxyExperienceSales.fullFillmentStatus'] = { operator: 'like', values: [`%${filterForm['DeluxyExperienceSales.fullFillmentStatus']}%`] };
    if (filterForm['DeluxyExperienceSales.deliveryMethod'])
      this.filtered['DeluxyExperienceSales.deliveryMethod'] = { operator: 'like', values: [`%${filterForm['DeluxyExperienceSales.deliveryMethod']}%`] };
    if (filterForm['DeluxyExperienceSales.address'])
      this.filtered['DeluxyExperienceSales.address'] = { operator: 'like', values: [`%${filterForm['DeluxyExperienceSales.address']}%`] };
    if (filterForm['DeluxyExperienceSales.phone'])
      this.filtered['DeluxyExperienceSales.phone'] = { operator: 'like', values: [`%${filterForm['DeluxyExperienceSales.phone']}%`] };
    if (filterForm['DeluxyExperienceSales.deliveryDate_from'])
      this.filtered['DeluxyExperienceSales.deliveryDate'] = { operator: 'moreThanOrEqual', values: [filterForm['DeluxyExperienceSales.deliveryDate_from']] };
    if (filterForm['DeluxyExperienceSales.deliveryDate_to'])
      this.filtered['DeluxyExperienceSales.deliveryDate'] = { operator: 'lessThan', values: [filterForm['DeluxyExperienceSales.deliveryDate_to']] };
    if (filterForm['DeluxyExperienceSales.deliveryDate_from'] && filterForm['DeluxyExperienceSales.deliveryDate_to'])
      this.filtered['DeluxyExperienceSales.deliveryDate'] = { operator: 'between', values: [filterForm['DeluxyExperienceSales.deliveryDate_from'], filterForm['DeluxyExperienceSales.deliveryDate_to']] };
    if (filterForm['DeluxyExperienceSales.vendor'])
      this.filtered['DeluxyExperienceSales.vendor'] = { operator: 'like', values: [`%${filterForm['DeluxyExperienceSales.vendor']}%`] };
    if (filterForm['DeluxyExperienceSales.status'])
      this.filtered['DeluxyExperienceSales.status'] = { operator: 'like', values: [`%${filterForm['DeluxyExperienceSales.status']}%`] };

    await this.getDeluxyExperienceOrders();
  }

  async getDeluxyExperienceOrders(limit?: number, page?: number, order?: {}) {
    this.page = page || parseInt(this.route.snapshot.queryParamMap.get('page')) || this.defaultPage;
    this.limit = limit || parseInt(this.route.snapshot.queryParamMap.get('limit')) || this.defaultLimit;
    this.order = order || JSON.parse(this.route.snapshot.queryParamMap.get('order')) || this.defaultOrder;
    let promiseResult = null;
    promiseResult = this.selected == 'active' ?
      this.deluxyExperienceSalesService.getDeluxyExperienceOrders(this.page, this.limit, this.order, this.filtered) :
      this.deluxyExperienceSalesService.getDeluxyExperienceOrdersHistory(this.page, this.limit, this.order, this.filtered);
    promiseResult.then((res) => {
      this.orders = res.orders;
      this.count = res.count;
      this.maxPage = Math.ceil(this.count / this.limit);
    }).catch((err) => {
      console.log("err", err)
    })
  }

  async confirmSale(saleOrder: any) {
      if(this.groups.includes('admin') || this.groups.includes('operation') || this.groups.includes('teamleader')){
        let delivery = await this.deliveryService.getDeliveryWithOrderId(saleOrder?.orderId, saleOrder?.realOrderNumber);
        if(delivery){
          this._snackBar.open(`This is unique product sale. Delivery has been created. Partner is still accpet or reject the sale`, 'Chiudi', {
            direction: "ltr",
            duration: 2000,
            horizontalPosition: "center",
            politeness: "assertive",
            verticalPosition: "top"
          });
          return false;
        }
        let ref = this.dialog.open(DeluxyExperienceSaleFormDialogComponent, { width: '80vw', data: { saleOrder } });
        ref.afterClosed().subscribe(async (result) => {
          if(result?.delivery){
            await this.getDeluxyExperienceOrders();
          }
        });
      } else {
        return false;
      }
    }

    async refuseSale(orderId: number) {
      if(!confirm(`Sei sicuro di voler rifiutare l'ordine di Deluxy Experience?`))
        return false;
      let promiseResult = await this.deluxyExperienceSalesService.refuseSaleByAdmin(orderId);
      if(promiseResult.success){
        this._snackBar.open(`L'ordine di Deluxy Experience è stato rifiutato. Puoi controllare nella cronologia`, 'Chiudi', {
          direction: "ltr",
          duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        });
        await this.getDeluxyExperienceOrders();
      } else {
       this._snackBar.open(`Qualcosa è andato storto`, 'Chiudi', {
        direction: "ltr",
        duration: 2000,
        horizontalPosition: "center",
        politeness: "assertive",
        verticalPosition: "top"
      });
      }
    }

    async stopSaleAutomation(sale:any) {
      if(!confirm(`Sei sicuro di voler stoppare l'automazione della vendita?`))
        return false;
      try{
        this.btnDisable = true;
        let id: number = sale?.id;
        let promiseResult = await this.deluxyExperienceSalesService.stopSaleAutomation(id, sale);
        if(promiseResult.success){
          this._snackBar.open(`Sale Automation has been Stopped.`, 'Chiudi', {
            direction: "ltr",
            duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        });
      }else{
        this._snackBar.open(`Something Went Wrong`, 'Chiudi', {
          direction: "ltr",
          duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        });
      }
      await this.getDeluxyExperienceOrders();
      }catch (error) {
        this.btnDisable = false;
        this._snackBar.open(`Something Went Wrong ${error?.error?.message}`, 'Chiudi', {
          direction: "ltr",
          duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        });  
      }
    }

    async resetFilter(){
      this.manageDeluxyExperienceSaleFilterForm();
      await this.filter();
    }
    async navigate(event){
      await this.getDeluxyExperienceOrders(event.limit, event.page, this.order);
    }

  public async navigateOrder(attribute: string | string[]) {
    delete this.order['DeluxyExperienceSales.updatedAt'];
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          this.order[attr] = 'DESC';
          break;
        case 'DESC':
          this.order[attr] = undefined;
          break;
        default:
          this.order = {}
          this.order[attr] = 'ASC';
          break;
      }
    }

    await this.navigatePage(this.limit, this.page, { order: this.order });
  }

    async navigatePage(limit: number, page: number, args: {} = {}){
      args = this.escapeQueryStringParams(args);
      const previousArgs = Object.keys(args).length ? {} : this.route.snapshot.queryParams;
      const newParams = { ...previousArgs };
      newParams[`limit`] = limit;
      newParams[`page`] = page;
      this.router.navigate(this.route.snapshot.url.map(u => u.path), { queryParams: { ...newParams, ...args } }).then(async () => {
        await this.getDeluxyExperienceOrders();
      });
    }

    private escapeQueryStringParams(args: {} = {}): {} {
      Object.keys(args).forEach(key => {
        switch (Object.prototype.toString.call(args[key])) {
          case '[object Number]':
          case '[object String]':
            break;
          case '[object Array]':
          case '[object Object]':
            args[key] = JSON.stringify(args[key]);
            break;
          default:
            delete args[key];
            break;
        }
      });
      return args;
    }

    public orderIcon(attribute: string | string[]): string {
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          return 'fa-sort-up';
        case 'DESC':
          return 'fa-sort-down';
        default:
          return 'fa-sort';
      }
    }
  }
}
